<div mat-dialog-content class="tool-form-container">
  <div class="form-title" [style]="{ background: env['colors']['primary'] }">
    {{ formTitle }}
  </div>
  <ng-content select=".form-btn-group"></ng-content>
  <div class="form-content-wrapper">
    <ng-content select=".form-content"></ng-content>
  </div>
</div>
